import React, { useEffect, useMemo, useState } from 'react';
import TableComponent from 'app/components/TableComponent';
import './styles/detalles.css';
import { KTSVG } from '_metronic/helpers';
import { formatDecimal, toaster } from 'app/utilities/commons';
import { useSelector } from 'react-redux';
import { RootState } from 'setup';
import { decodeToken } from 'app/utilities/decodeJWTToken';
import axios from 'axios';
import { CollaboratorCommissionAllResponse } from 'app/types/comisiones';
import {
  getAllCollaboratorRoster,
  getAllRosterCards,
  getLastRecord,
  getCollaboratorRosterName,
} from 'app/service/nomina/Nomina';
import { CollaboratorRosterAllResponse } from 'app/types/nomina';
import { FormControl, InputGroup, Modal } from 'react-bootstrap-v5';
import Swal from 'sweetalert2';
const API_URL = process.env.REACT_APP_API_NET;

type CollaboratorRoster = {
  id: number;
  periodId: number;
  collaboratorId: number;
  employeeName: string;
  employeeNumber: string;
  typeCollaborator: string;
  dailySalary: number;
  salary: number;
  perceptionImss: number;
  deductionImss: number;
  netSalary: number;
  diaryIncome: number;
  income: number;
  dayLab: number;
  dayFault: number;
  disability: number;
  perception: number;
  deduction: number;
  incomeNet: number;
  netPay: number;
  finallyDate?: string | null;
  finallyBy?: string | null;
};

type InputFields = {
  name: JSX.Element;
  number: JSX.Element;
};

const heads = [
  { code: 'employeeNumber', label: 'No. Empleado' },
  { code: 'typeCollaborator', label: 'Tipo' },
  { code: 'employeeName', label: 'Nombre' },
  { code: 'dailySalary', label: 'Diario IMSS' },
  { code: 'salary', label: 'Salario IMSS' },
  { code: 'perceptionImss', label: 'Percepciones IMSS' },
  { code: 'deductionImss', label: 'Deducciones IMSS' },
  { code: 'netSalary', label: 'Salario Neto' },
  { code: 'diaryIncome', label: 'Sueldo Diario' },
  { code: 'income', label: 'Sueldo' },
  { code: 'dayLab', label: 'Dias Lab' },
  { code: 'dayFault', label: 'Faltas' },
  { code: 'disability', label: 'Incapacidades' },
  { code: 'perception', label: 'Percepciones' },
  { code: 'deduction', label: 'Deducciones' },
  { code: 'incomeNet', label: 'Sueldo Neto' },
  { code: 'netPay', label: 'Total a Depositar' },
];

const filterOptions = [
  { id: '1', fecha: 'Nombre', field: 'name' },
  { id: '2', fecha: 'Número de Empleado', field: 'number' },
];

const DetalleNominaView: React.FC = () => {
  const [show, setShow] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [employeeName, setEmployeeName] = useState('');
  const [employeeNumber, setEmployeeNumber] = useState('');
  const [selectedOption, setSelectedOption] = useState('');
  const [rosterCards, setRosterCards] = useState<any>([]);
  const [lastPeriod, setLastPeriod] = useState<any>([]);
  const [isFiltered, setIsFiltered] = useState<boolean>(false);

  const [collaboratorRoster, setCollaboratorRoster] = useState<
    CollaboratorRoster[]
  >([]);
  const [loadingGrid, setLoadingGrid] = useState<boolean>(true);
  const [loadingInfo, setLoadingInfo] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  const accessToken: any = useSelector<RootState>(
    (state) => state.auth.accessToken
  );
  const token: any = decodeToken(accessToken);

  const [finallyDate, setFinallyDate] = useState<any>();
  const [periodId, setPeriodId] = useState<number>(0);

  const fetchRosterCards = async (page = currentPage, size = pageSize) => {
    try {
      const res = await getAllRosterCards(page, size);
      setRosterCards(res.records);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchLastPeriodRecord = async () => {
    try {
      const res = await getLastRecord();
      setLastPeriod(res);
    } catch (error) {}
  };

  const fetchPeriods = async () => {
    try {
      const res = await axios.get(`${API_URL}Period`);
      const filteredPeriod = res.data.data.records.filter(
        (record: { statusId: number }) => record.statusId === 1
      );
      setPeriodId(filteredPeriod[0].id);
    } catch (err) {
      console.error('Error al obtener los periodos:', err);
    }
  };
  useEffect(() => {
    fetchPeriods();
    fetchRosterCards(currentPage, pageSize);
    fetchLastPeriodRecord();
  }, []);

  const fetchCollaboratorRoster = async () => {
    try {
      const res = await getAllCollaboratorRoster(
        periodId,
        currentPage,
        pageSize
      );
      setPeriodId(res!.records[0].periodId);

      setCollaboratorRoster(
        res!.records.map((record) => ({
          ...record,
        }))
      );

      setFinallyDate(res!.records[0].finallyDate);

      setLoadingInfo(!loadingInfo);
      setTotalRecords(res!.totalRecords);
      setLoadingGrid(false);
    } catch (err) {
      // console.error('Error fetching Collaborator Roster', err);
    }
  };

  // useEffect(() => {
  //   fetchCollaboratorRoster();
  // }, [currentPage, pageSize, periodId, finallyDate]);

  useEffect(() => {
      if (isFiltered) {
        if (selectedOption === '1' && employeeName) {
          fetchCollaboratorCommissionFilterName(employeeName);
        } else if (selectedOption === '2' && employeeNumber) {
          fetchCollaboratorCommissionFilterNumber(employeeNumber);
        }
      } else {
        fetchCollaboratorRoster();
      }
    }, [currentPage, pageSize, isFiltered,periodId, finallyDate]);

  const fetchCollaboratorCommissionFilterName = async (
    employeeName?: string
  ) => {
    setIsFiltered(true);
    try {
      const res = await getCollaboratorRosterName(
        periodId,
        currentPage,
        pageSize,
        employeeName
      );
      setCollaboratorRoster(
        res.records.map((record: any) => ({
          ...record,
        }))
      );
      setTotalRecords(res.totalRecords);
      setLoadingGrid(false);
    } catch (err) {
      console.error(
        'Error al obtener los NAME Collaborator commission filters'
      );
    }
  };

  const fetchCollaboratorCommissionFilterNumber = async (
    employeeNumber?: string
  ) => {
    setIsFiltered(true);
    try {
      const response = await axios.get<CollaboratorRosterAllResponse>(
        `${API_URL}Roster?PeriodId=${periodId}&EmployeNumber=${employeeNumber}&Page=${currentPage}&PageSize=${pageSize}`
      );
      const res = response.data.data;
      setCollaboratorRoster(
        res.records.map((record) => ({
          ...record,
        }))
      );
      setTotalRecords(res.totalRecords);
      setLoadingGrid(false);
    } catch (err) {
      console.warn(
        'Error al obtener los NUMBER Collaborator commission filters',
        err
      );
    }
  };

  const rows = useMemo(() => {
    if (!loadingGrid && collaboratorRoster.length) {
      return collaboratorRoster.map((row) => ({
        employeeNumber: (
          <div style={{ textAlign: 'center', cursor: 'pointer' }}>
            {row.employeeNumber}
          </div>
        ),
        typeCollaborator: (
          <div style={{ textAlign: 'center' }}>{row.typeCollaborator}</div>
        ),
        employeeName: (
          <div style={{ textAlign: 'center' }}>{row.employeeName}</div>
        ),
        dailySalary: (
          <div style={{ textAlign: 'center' }}>
            ${formatDecimal.format(row.dailySalary)}
          </div>
        ),
        salary: (
          <div style={{ textAlign: 'center' }}>
            ${formatDecimal.format(row.salary)}
          </div>
        ),
        perceptionImss: (
          <div style={{ textAlign: 'center' }}>
            ${formatDecimal.format(row.perceptionImss)}
          </div>
        ),
        deductionImss: (
          <div style={{ textAlign: 'center' }}>
            ${formatDecimal.format(row.deductionImss)}
          </div>
        ),
        netSalary: (
          <div style={{ textAlign: 'center' }}>
            ${formatDecimal.format(row.netSalary)}
          </div>
        ),
        diaryIncome: (
          <div style={{ textAlign: 'center' }}>
            ${formatDecimal.format(row.diaryIncome)}
          </div>
        ),
        income: (
          <div style={{ textAlign: 'center' }}>
            ${formatDecimal.format(row.income)}
          </div>
        ),
        dayLab: <div style={{ textAlign: 'center' }}>{row.dayLab}</div>,
        dayFault: <div style={{ textAlign: 'center' }}>{row.dayFault}</div>,
        disability: <div style={{ textAlign: 'center' }}>{row.disability}</div>,
        perception: (
          <div style={{ textAlign: 'center' }}>
            ${formatDecimal.format(row.perception)}
          </div>
        ),
        deduction: (
          <div style={{ textAlign: 'center' }}>
            ${formatDecimal.format(row.deduction) || 0}
          </div>
        ),
        incomeNet: (
          <div style={{ textAlign: 'center' }}>
            ${formatDecimal.format(row.incomeNet)}
          </div>
        ),
        netPay: (
          <div style={{ textAlign: 'center' }}>
            ${formatDecimal.format(row.netPay)}
          </div>
        ),
      }));
    }
    return [];
  }, [collaboratorRoster, loadingGrid]);

  const handleFilterOpen = () => {
    setShowFilterModal(true);
  };

  const handleFilterClose = () => {
    setShowFilterModal(false);
  };

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedOption(e.target.value);
  };

  const handleSearch = () => {
    if (selectedOption === '1' && employeeName) {
      setIsFiltered(true);
      setCurrentPage(1);
      fetchCollaboratorCommissionFilterName(employeeName);
    } else if (selectedOption === '2' && employeeNumber) {
      setIsFiltered(true);
      setCurrentPage(1);
      fetchCollaboratorCommissionFilterNumber(employeeNumber);
    }
  };

  /**
   * Clean all the filters, inputs and fetch again the data
   */
  const handleClearFilters = () => {
    setEmployeeNumber('');
    setEmployeeName('');
    setSelectedOption('');
    setIsFiltered(false); 
    setCurrentPage(1); 
    fetchCollaboratorRoster(); 
  }

  const inputFields: InputFields = {
    name: (
      <>
        <div className="mt-4">
          <label className="form-label fw-bold">Nombre: </label>
        </div>
        <div>
          <input
            type="text"
            value={employeeName}
            className="form-control mt-4"
            onChange={(e) => setEmployeeName(e.target.value)}
          />
          <div className="mt-4 d-flex flex-row-reverse">
            <button
              type="submit"
              className="btn btn-primary"
              data-kt-menu-dismiss="true"
              onClick={(e) => {
                e.preventDefault();
                handleSearch();
                handleFilterClose();
              }}
            >
              Buscar
            </button>
            <button
              type="reset"
              className="btn btn-white btn-active-light-primary me-2"
              data-kt-menu-dismiss="true"
              onClick={(e) => {
                e.preventDefault();
                handleFilterClose();
                handleClearFilters();
              }}
            >
              Limpiar
            </button>
          </div>
        </div>
      </>
    ),
    number: (
      <>
        <div className="mt-4">
          <label className="form-label fw-bold">Número de Empleado: </label>
        </div>
        <div>
          <input
            type="text"
            value={employeeNumber}
            className="form-control mt-4"
            onChange={(e) => setEmployeeNumber(e.target.value)}
          />
          <div className="mt-4 d-flex flex-row-reverse">
            <button
              type="submit"
              className="btn btn-primary"
              data-kt-menu-dismiss="true"
              onClick={(e) => {
                e.preventDefault();
                handleSearch();
                handleFilterClose();
              }}
            >
              Buscar
            </button>
            <button
              type="reset"
              className="btn btn-white btn-active-light-primary me-2"
              data-kt-menu-dismiss="true"
              onClick={(e) => {
                e.preventDefault();
                handleFilterClose();
                handleClearFilters();
              }}
            >
              Limpiar
            </button>
          </div>
        </div>
      </>
    ),
  };

  const fieldToShow = filterOptions.find(
    (option) => option.id === selectedOption
  )?.field;

  const isAuthorizeBtnDisabled = useMemo(() => {
    return (
      collaboratorRoster.length === 0 ||
      collaboratorRoster.some((record) => record.finallyDate)
    );
  }, [collaboratorRoster]);

  const isRequestBtnDisabled = useMemo(() => {
    return (
      collaboratorRoster.length === 0 ||
      collaboratorRoster.some((record) => record.finallyDate)
    );
  }, [collaboratorRoster]);

  const finalRosterCollaborator = async (idUser: number, idPeriod: number) => {
    try {
      const res = await axios.get(
        `${API_URL}Roster/FinalRosterCollaborator?Id_user=${idUser}&Id_period=${idPeriod}`
      );
      fetchCollaboratorRoster();
      toaster.success(res.data.data.mensaje || 'Cierre de periodo finalizado exitosamente');
    } catch (err) {
      console.error('Error requesting authorization: ', err);
    }
  };

  const refreshRosterCollaborator = async (
    idUser: number,
    idPeriod: number
  ) => {
    try {
      const res: any = await axios.get(
        `${API_URL}Roster/RefreshRosterCollaborator?Id_user=${idUser}&Id_period=${idPeriod}`
      );
      fetchCollaboratorRoster();
      toaster.success(
        res.data.data.mensaje || 'Procedimiento ejecutado exitosamente'
      );
    } catch (err) {
      console.error('Error requesting authorization: ', err);
    }
  };

  return (
    <div className="row gy-5 g-xl-8">
      <div className="col-xxl-12 col-xl-12 col-md-12 col-lg-12">
        <div className="card card-flush p-5">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex">
              <div className="me-3">
                <label className="form-label">Cierre de Nómina</label>
                <input
                  type="text"
                  className="form-control"
                  value={finallyDate || 'N/A'}
                  disabled
                />
              </div>
            </div>

            <div className="d-flex align-items-center align-self-end">
              <button
                className="btn btn-light-primary border-btn w-10"
                onClick={handleFilterOpen}
              >
                <KTSVG
                  path="/media/icons/duotune/general/gen021.svg"
                  className="svg-icon svg-icon-5 svg-icon-gray-500"
                />
                <span className="ms-2">Filtrar</span>
              </button>
            </div>
          </div>

          <TableComponent
            heads={heads}
            rows={rows}
            rowsPerPage={pageSize}
            page={currentPage}
            totalRows={totalRecords}
            setPage={setCurrentPage}
          />
          <div className="d-flex flex-row-reverse ">
            <button
              type="submit"
              disabled={isRequestBtnDisabled}
              className="btn btn-primary "
              onClick={(e) => {
                e.preventDefault();
                // Llegan como strings por eso se pusieron asi xdxd
                if (lastPeriod.comisiones === 'false') {
                  toaster.error('No has cerrado comisiones');
                }

                if (lastPeriod.ajustes === 'false') {
                  toaster.error('No has cerrado ajustes');
                }

                if (lastPeriod.bonos === 'false') {
                  toaster.error('No has cerrado bonos');
                }

                if (
                  lastPeriod.comisiones === 'true' &&
                  lastPeriod.ajustes === 'true' &&
                  lastPeriod.bonos === 'true'
                ) {
                  Swal.fire({
                    title: '¿Desea finalizar la nómina?',
                    text: 'Una vez finalizada ya no se podrá modificar ningún dato de esta nómina.',
                    icon: 'question',
                    showCancelButton: true,
                    padding: '2em',
                    cancelButtonText: 'Cancelar',
                    confirmButtonText: 'Aceptar',
                    reverseButtons: true,
                    customClass: {
                      confirmButton: 'btn btn-primary',
                      cancelButton: 'btn btn-light me-3',
                    },
                  }).then((result) => {
                    if (result.isConfirmed) {
                      finalRosterCollaborator(token.nameid, periodId);
                    }
                  });
                }
              }}
            >
              Finalizar Nómina
            </button>
            <button
              type="submit"
              className="btn btn-primary me-4"
              disabled={isAuthorizeBtnDisabled}
              onClick={(e) => {
                e.preventDefault();
                refreshRosterCollaborator(token.nameid, periodId);
              }}
            >
              Actualizar Nómina
            </button>
          </div>
        </div>
      </div>

      <Modal
        id="kt_modal_filter"
        tabIndex={-1}
        aria-hidden="true"
        dialogClassName="modal-dialog"
        show={showFilterModal}
        onHide={handleFilterClose}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="text-muted mx-5">Filtrar Resultados</h1>
            <div
              className="btn btn-sm btn-icon btn-active-color-primary"
              onClick={handleFilterClose}
            >
              <KTSVG
                className="svg-icon-2"
                path="/media/icons/duotune/arrows/arr061.svg"
              />
            </div>
          </div>
          <div className="modal-body mx-5 padding-top-00">
            <div className="mt-4">
              <label className="form-label fw-bold">
                Seleccione una opción:
              </label>
            </div>
            <select
              className="form-select"
              value={selectedOption}
              onChange={handleSelectChange}
            >
              <option value="">Seleccione</option>
              {filterOptions.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.fecha}
                </option>
              ))}
            </select>
            {fieldToShow && inputFields[fieldToShow as keyof InputFields]}
          </div>
          <div className="modal-body mx-5 padding-top-00"></div>
        </div>
      </Modal>
    </div>
  );
};

export { DetalleNominaView };
